import BaseAPI from '@/apis/base/baseApi';
/**
 * GHi sổ
 * NXCHIEN 26.06.2022
 */
export default class LGAPI extends BaseAPI {
  apiName = 'LG';
}
